import {
    Dispatch,
    SetStateAction,
    useCallback,
    useEffect,
    useRef,
    useState,
} from "react"; 
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import {
    ClienteInterface,
    IClienteFilter,
} from "../../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";

import ClientesRow from "../clientesRow";
import { ListarClientesRegistraVendaController } from "../../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { IPropsTableChange } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

interface ITabelaCliente {
    setCliente: Dispatch<SetStateAction<any>>;
    setShow: Dispatch<SetStateAction<boolean>>;
}

const filtroInicial = {
    DS_EMAIL: "",
    DS_NOME: "",
    NR_CPF: "",
    NR_TELEFONE: "",
    ID_EMPREENDIMENTO: undefined,
    ID_UNIDADE: 0,
    ID_CASO: 0,
    FL_CHAVE_ERP: false,
};

export default function TabelaCliente(props: ITabelaCliente) {
    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CONTA",
            text: "",
            formatter: (_c, row) => <ClientesRow row={row} />,
        },
    ];
    const ultimaPesquisaRef = useRef("");
    const [pesquisaText, setPesquisaText] = useState("");

    const [lstClientes, setLstClientes] = useState<Array<ClienteInterface>>();
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [filter, setFilter] = useState<IClienteFilter>(filtroInicial);
    const [loading, setLoading] = useState(false);
    const [pagina, setPagina] = useState(1);

    useEffect(() => {
        updateClientes(pagina, filter);

        // eslint-disable-next-line
    }, [filter, pagina]);


    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;
        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                if (!searchValue.replace(/\D/g, "")) {
                    setFilter({
                        DS_NOME: newState.searchText,
                    });
                } else {
                    setFilter({
                        NR_CPF: newState.searchText,
                    });
                }
                setTotalPaginas(newState.page);
            }
        }, 750);
    }
    const rowEvents = {
        onClick: (_e: any, row: any) => {
            props.setCliente(row);
            props.setShow(false);
        },
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateClientes = useCallback(
        (page: number, filter: IClienteFilter) => {
            setLoading(true);
            ListarClientesRegistraVendaController(page, {
                ...filter,
            })
                .then((response) => {
                    setLstClientes(response.LISTA_CLIENTES);
                    setTotalPaginas(response.NR_TOTAL_PAGINAS);
                })
                .finally(() => {
                    setLoading(false);
                });
        },
        []
    );

    useEffect(() => {
        updateClientes(pagina, filter);
        // eslint-disable-next-line
    }, [filter, pagina]);

    return (
        <div className="cardsTable mt-3">
            {lstClientes || loading ? (
                <Table
                    keyField={"ID_CONTA"}
                    data={lstClientes || []}
                    columns={columns}
                    rowClasses="checkbox-table"
                    rowEvents={rowEvents}
                    page={pagina}
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;
                        if (state.searchText !== pesquisaText) {
                            handleSearch(state.searchText, state);
                            setPesquisaText(state.searchText);
                            newState.page = 1;
                            setPagina(1);
                        } else {
                            setTotalPaginas(state.page);
                            setPagina(state.page);
                        }
                    }}
                    noDataIndication={
                        <div className="text-muted text-center">
                            Nenhum cliente encontrado
                        </div>
                    }
                    loading={loading}
                    remote={{ pagination: true }}
                    totalPages={totalPaginas}
                    noHover
                />
            ) : (
                <div className="text-muted text-center">
                    Faça a busca com o menu ao lado para ver os clientes
                </div>
            )}
        </div>
    );
}
